module.exports = __webpack_public_path__ + "static/media/2-solution-0.ab78fa69.mp3";